import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const refreshSegmentCount = {
  name: "refreshSegmentCount" as const,
  input: zExt.objectId(),
  output: z.object({
    allCount: z.number(),
    emailEligibleCount: z.number(),
    emailSubscriberCount: z.number(),
    smsSubscriberCount: z.number(),
  }),
};
